import React, { useEffect, useState } from 'react';

const useDocumentActive = () => {
  const [isDocumentVisible, setIsDocumentVisible] = useState(!document.hidden);

  useEffect(() => {
    const handleVisibilityChange = () => setIsDocumentVisible(!document.hidden);

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return isDocumentVisible;
};

export default useDocumentActive;
